/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Return_Decision_Reconcile_RequiredInputs */

const vi_carrier_return_decision_reconcile_required = /** @type {(inputs: Carrier_Return_Decision_Reconcile_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cần đối soát phản hồi với Viettel Post trước khi thao tác tiếp`)
};

/**

* @param {Carrier_Return_Decision_Reconcile_RequiredInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_return_decision_reconcile_required = /** @type {((inputs?: Carrier_Return_Decision_Reconcile_RequiredInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Return_Decision_Reconcile_RequiredInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_return_decision_reconcile_required(inputs)
});